import { Paper, Text } from '@mantine/core'
import { useState } from 'react'
import { UPLOAD_LIMITS } from '../types/upload-types'
import { Icon } from '@/components/icon'
import { faUpload } from '@fortawesome/free-solid-svg-icons'

interface FileInputProps {
  handleFileChange: React.ChangeEventHandler<HTMLInputElement>
}

export function FileInput({ handleFileChange }: FileInputProps) {
  const [isDragging, setIsDragging] = useState(false)

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault()
    setIsDragging(true)
  }

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault()
    setIsDragging(false)
  }

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault()
    setIsDragging(false)

    const droppedFiles = Array.from(e.dataTransfer.files)
    const input = document.getElementById('file') as HTMLInputElement
    if (input) {
      const dataTransfer = new DataTransfer()
      droppedFiles.forEach((file) => dataTransfer.items.add(file))
      input.files = dataTransfer.files

      // Trigger the change event
      const event = new Event('change', { bubbles: true })
      input.dispatchEvent(event)
    }
  }

  return (
    <div>
      <input
        type="file"
        multiple
        name="files"
        id="file"
        className="sr-only"
        onChange={handleFileChange}
        accept=".pdf,.xls,.xlsx,.xlsm,.json,.csv,.txt,.dat"
      />
      <Paper
        component="label"
        htmlFor="file"
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        className={`flex min-h-[180px] cursor-pointer flex-col items-center justify-center border-2 border-dashed p-6 transition-all ${
          isDragging
            ? 'border-blue-500 bg-blue-50'
            : 'border-gray-300 hover:border-gray-400 hover:bg-gray-50'
        }`}
        radius="md"
      >
        <Icon
          icon={faUpload}
          size={40}
          className={`mb-3 ${isDragging ? 'text-blue-500' : 'text-gray-400'}`}
        />
        <Text size="sm" fw={500} mb="xs">
          {isDragging
            ? 'Drop files here'
            : 'Click to select or drag and drop files'}
        </Text>
        <Text size="xs" c="dimmed" ta="center">
          PDF, Excel, JSON, CSV, TXT, or DAT (Max {UPLOAD_LIMITS.MAX_FILES}{' '}
          files, {UPLOAD_LIMITS.MAX_FILE_SIZE / (1024 * 1024)} MB each)
        </Text>
      </Paper>
    </div>
  )
}
